import React, { useState, ComponentProps } from 'react';
import classnames from 'classnames';
import { triggerSignUp } from '@fiverr-private/identification_triggers';
import { Button } from '@fiverr-private/fit';
import pathfinder from '@fiverr-private/pathfinder';
import withTranslation from '../../lib/withTranslation';
import { sendBigQueryEvent } from '../../utils/bigQuery';
import { sendMixPanelEvent } from '../../utils/mixPanel';
import { BIGQUERY_EVENT } from './constants';
import './style.scss';

interface JoinLinkProps {
    fill?: ComponentProps<typeof Button>['fill'];
    color?: ComponentProps<typeof Button>['color'];
    size?: ComponentProps<typeof Button>['size'];
    textColor?: ComponentProps<typeof Button>['textColor'];
    i18n: any;
    isThemed?: boolean;
}

const JoinLink = ({
    fill = (Button as any).FILLS.GHOST,
    color = (Button as any).TEXT_COLORS.GREEN,
    size = (Button as any).SIZES.SMALL,
    textColor,
    i18n,
    isThemed = false,
}: JoinLinkProps) => {
    const [loading, setLoading] = useState(false);

    const triggerClassName = classnames('fiverr-header-join', { 'themed-link': isThemed });

    const path = pathfinder(
        'join',
        {},
        {
            query: {
                source: 'top_nav',
            },
        }
    );

    const handleClick = async (event) => {
        sendMixPanelEvent({
            eventName: 'Header join button clicked',
            eventData: {},
        });
        sendBigQueryEvent(BIGQUERY_EVENT);

        try {
            event.preventDefault();
            setLoading(true);

            await triggerSignUp({
                modalOptions: { source: 'header_join_link' },
            });
        } catch {
            window.location.assign(path);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button
            href={path}
            loading={loading}
            rel="nofollow"
            color={color}
            textColor={textColor}
            fill={fill}
            size={size}
            className={triggerClassName}
            onClick={handleClick}
        >
            {i18n.t('header.join')}
        </Button>
    );
};

export default withTranslation(JoinLink);
